import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { UsanFormSectionStates } from '../models/usan-form-section-states.model';
import { FormService } from './form.service';
import { FormGroup } from '@angular/forms';
import { FormConstants } from 'app/constants/form.constants';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {

  constructor(protected formService: FormService) {}

  private sideNavOpenedValue!: boolean;

  private sideNavOpenedSubject = new Subject<any>();

  private usanFormType = '';

  private usanFormTypeSubject = new Subject<any>();

  private usanFormSectionStates: UsanFormSectionStates = new UsanFormSectionStates();

  private usanFormSectionStatesSubject = new Subject<any>();

  private usanFormTab = '';

  private usanFormTabSubject = new Subject<any>();

  sendSideNavOpenedUpdate(isOpened: boolean) {
    this.sideNavOpenedValue = isOpened;
    this.sideNavOpenedSubject.next({value: isOpened});
  }

  getSideNavOpenedUpdate(): Observable<any> {
    return this.sideNavOpenedSubject.asObservable();
  }

  getSideNavOpenedValue(): boolean {
    return this.sideNavOpenedValue;
  }

  sendUsanFormTypeUpdate(formType: string) {
    const type = FormConstants.FORM_TYPE_TRANSLATION_MAP.get(formType);
    this.usanFormType = type ? type : formType;
    this.usanFormTypeSubject.next({value: formType});
  }

  getUsanFormTypeUpdate(): Observable<any> {
    return this.usanFormTypeSubject.asObservable();
  }

  getUsanFormTypeValue(): string {
    return this.usanFormType;
  }

  saveFormandSendUsanFormSectionStatesUpdate(formSection: string) {
    this.formService.createOrSaveCase().subscribe();
    this.sendUsanFormSectionStatesUpdate(formSection);
  }

  sendUsanFormSectionStatesUpdate(formSection: string) {
    this.formService.invalidFormFields();
    this.usanFormSectionStates.updateShownPanel(formSection);
    this.usanFormSectionStatesSubject.next({value: this.usanFormSectionStates});
    if(formSection === 'showUploadDocumentsPanel') {
      this.usanFormTab = 'upload-documents';
      this.usanFormTabSubject.next({value: 'upload-documents'});
    } else if(formSection === 'showPaymentInfoPanel') {
      this.usanFormTab = 'fee-info';
      this.usanFormTabSubject.next({value: 'fee-info'});
    } else if(formSection === 'showTermsAndConditionsPanel') {
      this.formService.forceValidateForm();
      this.formService.showErrorSections();
    } else {
      this.usanFormTab = 'application-form';
      this.usanFormTabSubject.next({value: 'application-form'});
    }
  }


  getUsanFormSectionStatesUpdate(): Observable<any> {
    return this.usanFormSectionStatesSubject.asObservable();
  }

  getUsanFormSectionValue(): UsanFormSectionStates {
    return this.usanFormSectionStates;
  }

  sendUsanFormTabUpdate(formTab: string, saveCase: boolean) {
    let formSection;
    
    if(formTab === 'application-form') {
      formSection = 'showBasicInfoPanel';
    }
    
    if(formTab === 'upload-documents') {
      formSection = 'showUploadDocumentsPanel';
    }
    
    if(formTab === 'fee-info') {
      formSection = 'showPaymentInfoPanel';
    }

    if(formSection)
      this.usanFormTab = formTab;
      this.usanFormTabSubject.next({value: formTab});
      
      if(saveCase) {
        this.saveFormandSendUsanFormSectionStatesUpdate(formSection);
      } else {
        this.sendUsanFormSectionStatesUpdate(formSection);
      }
  }

  getUsanFormTabUpdate(): Observable<any> {
    return this.usanFormTabSubject.asObservable();
  }

  getUsanFormTabValue(): string {
    return this.usanFormTab;
  }

  get currentForm(): FormGroup {
    return this.formService.getCurrentUsanFormValue();
  }

}
